import React from "react";
import { ArrowRight, Clock } from "tabler-icons-react";
import { isSecondaire } from "utils/niveaux";

/** Habillage par matière : libellé lisible, couleur et accroche. */
const META = {
  MATHEMATIQUE: {
    label: "Mathématiques",
    subtitle: "Évalue le niveau et repère les lacunes.",
    duree: "≈ 10 min",
    color: "#0E9F6E",
    cta: "Commencer",
  },
  LECTURE: {
    label: "Lecture",
    subtitle: "Évalue la fluidité et la compréhension.",
    duree: "≈ 10 min",
    color: "#027AFC",
    cta: "Commencer",
  },
  "AIDE AUX DEVOIRS": {
    label: "Aide aux devoirs",
    subtitle: "Photographiez l'exercice, Genimi vous guide.",
    duree: "≈ 2 min",
    color: "#F59E0B",
    cta: "Ouvrir",
  },
};

/**
 * Collège / lycée : il n'existe pas de diagnostic de niveau pour eux.
 * Ce contenu sert uniquement à montrer comment Genimi interroge l'enfant,
 * on l'annonce donc pour ce qu'il est.
 */
const DEMO_META = {
  label: "Comment marche Genimi",
  subtitle: "Découvrez comment Genimi marche",
  duree: "≈ 5 min",
  color: "#003B7F",
  cta: "Découvrir",
  demo: true,
};

const isDiagnostic = (name) =>
  ["MATHEMATIQUE", "LECTURE"].includes(String(name ?? "").toUpperCase());

const getMeta = (name, classe) => {
  if (isDiagnostic(name) && isSecondaire(classe)) return DEMO_META;

  return (
    META[String(name ?? "").toUpperCase()] ?? {
      label: name,
      subtitle: "Diagnostic de niveau.",
      duree: null,
      color: "#003B7F",
      cta: "Commencer",
    }
  );
};

function MatiereCard({ onClick, name, img, classe, className }) {
  const meta = getMeta(name, classe);
  const icon = meta.demo ? "icon1" : img;

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onClick?.();
      }}
      className={`w-full bg-white rounded-2xl border border-black/[0.07] p-4 cursor-pointer shadow-[0_10px_24px_-20px_rgba(0,0,0,0.7)] active:scale-[0.99] transition-transform ${
        className ?? ""
      }`}
      data-testid="matiere-card"
    >
      <div className="flex gap-3">
        <div
          className="h-12 w-12 rounded-2xl flex items-center justify-center shrink-0"
          style={{ backgroundColor: meta.color }}
        >
          <img
            src={`/icons/${icon}.png`}
            alt=""
            className="w-6 h-6 object-contain brightness-0 invert"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-primary text-[17px] leading-tight">
            {meta.label}
          </h3>
          <p className="text-[13px] text-primary/45 leading-snug mt-0.5">
            {meta.subtitle}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between gap-3 mt-3">
        {meta.duree ? (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-black/[0.05] text-primary/60 px-2.5 py-1 text-[12px] font-semibold">
            <Clock size={14} />
            {meta.duree}
          </span>
        ) : (
          <span />
        )}

        <span
          className="shrink-0 h-11 px-6 rounded-full text-white font-bold text-[14px] flex items-center gap-2"
          style={{ backgroundColor: meta.color }}
        >
          {meta.cta}
          <ArrowRight size={17} />
        </span>
      </div>
    </div>
  );
}

export default MatiereCard;
